const product = require('./product');

let museDirtyEndpoint = null;
let lmnEndpoint = null;
let mu2Endpoint = null;

const museDirtyProducts = [
  product.skus.TJH,
];

// Muse dirty products are split up by locale, e.g. KOY has 4 locales (en, es,
// it, nl) so it has four products (kingdom-of-you-en, ...).
const mu2ProductsPerLocale = [
  product.skus.KOY,
  product.skus.MGT,
  product.skus.TBT,
];

const isChameleon = sku => sku === product.skus.LMN;
const isMuseDirty = sku => museDirtyProducts.includes(sku);
const isMu2PerLocale = sku => mu2ProductsPerLocale.includes(sku);
const isMu2 = sku => !isChameleon(sku) && !isMuseDirty(sku);

const selectMuseEndpoint = sku => {
  if (isMuseDirty(sku)) {
    return museDirtyEndpoint;
  }
  return mu2Endpoint;
};

const createProductCode = (sku, productKey, locale) => {
  switch (true) {
    case isMu2PerLocale(sku):
      return `${sku}-${locale}`;
    case isMu2(sku):
      return sku;
    default:
      return product.museIds[productKey];
  }
};

const createMuseBaseUrl = (productKey, locale) => {
  const sku = product.skus[productKey];
  const endpoint = selectMuseEndpoint(sku);
  const productCode = createProductCode(sku, productKey, locale);
  return endpoint.replace('{sku}', productCode);
};

const setMUSEDirtyEndpoint = value => {
  museDirtyEndpoint = value;
  return module.exports;
};

const setMU2Endpoint = value => {
  mu2Endpoint = value;
  return module.exports;
};

const setLMNEndpoint = value => {
  lmnEndpoint = value;
  return module.exports;
};

const getPreviewBaseUrl = (sku, locale) => {
  switch (sku) {
    case product.skus.LMN:
      return lmnEndpoint;
    default:
      const productKey = product.findKeyBy.sku(sku);
      if (!product.museIds[productKey]) {
        throw new Error(`unsupported sku ${sku}`);
      }
      return createMuseBaseUrl(productKey, locale);
  }
};

const buildPreviewUrl = (sku, params) => {
  // According to @robertwatts there will never be an english locale that isn't "en"
  const locale = params.locale.startsWith('en') ? 'en' : params.locale;
  const url = getPreviewBaseUrl(sku, locale);

  if (isMuseDirty(sku)) {
    return url.replace(
      '{locale}',
      locale,
    );
  }

  return url;
};

module.exports = {
  isMuseDirty,
  isMu2,
  isChameleon,
  setLMNEndpoint,
  setMUSEDirtyEndpoint,
  setMU2Endpoint,
  getPreviewBaseUrl,
  buildPreviewUrl,
};



// WEBPACK FOOTER //
// ./src/common/config/endpoints.js